/**
 * "Complete the look" row (snippets/kor-complete-the-look.liquid).
 * Touch users swipe the strip natively. Mouse/pen users get prev/next buttons, shown
 * only when the strip overflows and disabled at either end.
 */
if (!customElements.get('kor-complete-the-look')) {
  class KorCompleteTheLook extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-ctl-list]');
      this.nav = this.querySelector('.kor-ctl__nav');
      this.prev = this.querySelector('[data-ctl-prev]');
      this.next = this.querySelector('[data-ctl-next]');
      if (!this.list || !this.nav || !this.prev || !this.next) {
        return;
      }
      // Listeners once; the observer again on every (re)connect, disconnectedCallback drops it.
      if (!this.ready) {
        this.ready = true;
        this.finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.prev.addEventListener('click', () => this.page(-1));
        this.next.addEventListener('click', () => this.page(1));
        this.list.addEventListener('scroll', () => this.update(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.update());
      }
      this.resizeObserver.observe(this.list);
      this.update();
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    page(direction) {
      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.list.scrollBy({ left: direction * this.list.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    }

    update() {
      const overflow = this.list.scrollWidth - this.list.clientWidth > 1;
      this.nav.hidden = !(overflow && this.finePointer.matches);
      this.prev.disabled = this.list.scrollLeft <= 1;
      this.next.disabled = this.list.scrollLeft >= this.list.scrollWidth - this.list.clientWidth - 1;
    }
  }
  customElements.define('kor-complete-the-look', KorCompleteTheLook);
}
